import { Container, Sprite, Text, TextStyle, Texture } from "pixi.js";
import { StringFormatExtention } from "../../../../extensions/StringFormatExtention";

export class MonField extends Container {
    private valueText: Text;
    private monIcon: Sprite;
    private spacing: number;

    public constructor(value: number, icon: Texture, textStyle: TextStyle, spacing: number = 20) {
        super();
        this.spacing = spacing;
        this.valueText = new Text(StringFormatExtention.formatWithComma(value.toFixed(2)), textStyle);
        this.monIcon = new Sprite(icon);
        this.monIcon.position.set(this.valueText.width + spacing, this.valueText.height * 0.5 - this.monIcon.height * 0.5 - 3);
        this.monIcon.width = 60;
        this.monIcon.height = 60;
        this.addChild(this.valueText, this.monIcon);
    }

    public updatePrice(value: number): void {
        this.valueText.text = StringFormatExtention.tokensFormat(value.toString());
        this.monIcon.position.set(this.valueText.width + this.spacing, this.valueText.height * 0.5 - this.monIcon.height * 0.5 - 3);
    }
}
